import AboutMimo from "./aboutMimo";
export default AboutMimo